import React from "react";

export function BrandMark({ size = 36, className = "" }) {
  const s = `${size}px`;
  return (
    <img
      src="/book-it-logo.png"
      alt="Book-It"
      style={{ width: s, height: s, objectFit: "contain" }}
      className={`select-none ${className}`}
      draggable={false}
    />
  );
}

export function BrandLogo({ subtitle = false, size = 38 }) {
  return (
    <div className="flex items-center gap-2.5">
      <BrandMark size={size} />
      <div className="leading-none">
        <p className="font-display text-lg tracking-tight">
          Book<span className="text-[hsl(var(--accent))]">-</span>It
        </p>
        {subtitle && (
          <p className="text-[10px] uppercase tracking-[0.18em] text-slate-500 mt-1">
            Smart Booking Platform
          </p>
        )}
      </div>
    </div>
  );
}
